export default "__VITE_ASSET__lhE5viRt__"